import { z } from 'zod';
import { listingValues, numberParameter, switchParameter } from './shared.js';

// Macro-PLUS p265 and installed SETVIG.SEQ (2026 Update 0.1): these are
// RFD defaults, not application estimates. The macro accepts NUM arguments,
// takes ABSF of resolution, and handles convergence itself.
const vignettingSettings = z.strictObject({
  radial_resolution: z.number().default(1e-7).describe('Precision as a fraction of entrance-pupil radius. SETVIG uses the absolute value; native default 1e-7.'),
  initial_radial_step: z.number().default(0.1).describe('Initial radial search increment as a fraction of entrance-pupil radius; native default 0.1.'),
  iteration_limit: z.number().default(100).describe('Native iteration counter limit for each vignetting factor; default 100. The supplied macro accepts a numeric value.'),
  include_obscurations: z.enum(listingValues).default('No').describe('Whether the native search treats obscurations as blocking apertures; default No.'),
  check_ray_failures: z.enum(listingValues).default('Yes').describe('Whether SETVIG checks and reports factors set by ray failures rather than blocking apertures; default Yes.'),
});

export default {
    label: 'Vignetting Factors', group: 'performance',
    description: 'Vignetting factors that clip the entrance pupil in the +X, -X, +Y and -Y directions.',
    settingsSchema: vignettingSettings,
    parameters: [
      numberParameter('radial_resolution', 'Radial resolution', { unit: 'pupil radius' }),
      numberParameter('initial_radial_step', 'Initial radial step', { unit: 'pupil radius' }),
      numberParameter('iteration_limit', 'Iteration limit'),
      switchParameter('include_obscurations', 'Include obscurations'),
      switchParameter('check_ray_failures', 'Check ray failures'),
    ],
    coverage: 'Factors are calculated on a copy of the lens and are not saved to your design; Auto-calc vignetting in the Lens Data Editor calculates them with the default settings and saves them. Narrow annular apertures and strong higher-order spherical aberration can stop the calculation from converging; factors that fail are not shown.',
  } as const;
